var initializeModalCarousel = function() {
    jQuery('.slick-modal:not(.slick-initialized)').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 1,
        slidesPerRow: 1,
        dots: false,
        arrows: true,
        autoplay: false,
        fade: false,
        easing: "linear",
        pauseOnHover: false,
        infinite: true,
        draggable: false,
        swipe: true,
        adaptiveHeight: true
    });
};

var initializeBlockCarousel = function(block){
    
	var $block = jQuery(block);
	var $wrapper = $block.children().first(); // Get the first child div which has our type class
	var count = jQuery(".slick > *", $block).length;
	var isVertical = $wrapper.hasClass('type-vertical_content');
	var isImages = $wrapper.hasClass('type-images');
	var isLargeImages = $wrapper.hasClass('type-images_large');
	var showDots = isLargeImages ? true : ((isVertical || isImages) ? false : (count < 2 ? false : true));

    jQuery('.slick:not(.slick-initialized)', $block).slick({ 
		slidesToShow: isLargeImages ? 1 : (isImages ? 3 : 1),
		slidesToScroll: 1,
		centerMode: isVertical && isImages,
		rows: 1,
		slidesPerRow: 1,
		dots: showDots,
		arrows: !isLargeImages, 
		autoplay: isVertical, 
		autoplaySpeed: 3000, 
		fade: !isVertical && !isImages && !isLargeImages,
 		vertical: isVertical,
		verticalSwiping: isVertical,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		prevArrow: '<button type="button" class="slick-prev">Previous</button>',
		nextArrow: '<button type="button" class="slick-next">Next</button>',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: false,
                    fade: false
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: false,
                    fade: false
                }
            }
        ]
	});
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    // Initialize carousels
    jQuery('.wp-block-carousel').each(function(){
        initializeBlockCarousel(jQuery(this));
    });

    // Initialize modal carousel
    initializeModalCarousel();
    
    // Handle modal opening
    jQuery(document).on('opening', '.remodal', function(){
        setTimeout(function(){
            jQuery('.slick-modal').slick("refresh");
        }, 50);
    });
    
    // Handle slide clicks for modal
    jQuery('.type-images .slide').on('click', function(){
        var $carousel = jQuery(this).closest('.slick');
        var currentSlide = $carousel.slick('slickCurrentSlide');
        var slideIndex = jQuery(this).data('slick-index');
        var relativeIndex = slideIndex - currentSlide;
        var remodalID = jQuery(this).attr("data-remodal-target");
        jQuery('.remodal[data-remodal-id="' + remodalID + '"] .slick-modal').slick("slickGoTo", slideIndex);
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=carousel', initializeBlockCarousel);
